class BrickMagazineProduct {
  constructor(root) {
    this.root = root;
    this.slides = [...root.querySelectorAll('[data-magazine-slide]')];
    this.variants = [...root.querySelectorAll('[data-magazine-variant]')];

    this.caption = root.querySelector('[data-magazine-caption]');
    this.price = root.querySelector('[data-magazine-price]');
    this.variantInput = root.querySelector('[data-magazine-variant-input]');
    this.addButton = root.querySelector('[data-magazine-add]');

    this.prev = root.querySelector('[data-magazine-prev]');
    this.next = root.querySelector('[data-magazine-next]');

    this.index = Math.max(
      0,
      this.slides.findIndex(slide => slide.classList.contains('is-active'))
    );

    this.prev?.addEventListener('click', () => this.show(this.index - 1));
    this.next?.addEventListener('click', () => this.show(this.index + 1));

    this.variants.forEach(button => {
      button.addEventListener('click', () => this.selectVariant(button));
    });

    this.show(this.index);
  }

  show(index) {
    if (!this.slides.length) return;

    if (index < 0) index = this.slides.length - 1;
    if (index >= this.slides.length) index = 0;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });

    this.index = index;

    const slide = this.slides[index];

    if (this.caption) {
      this.caption.textContent = slide.dataset.caption || `FIG. ${index + 1}`;
    }
  }

  selectVariant(button) {
    this.variants.forEach(item => {
      const active = item === button;

      item.classList.toggle('is-active', active);

      const bullet = item.querySelector('.brick-magazine-product__bullet');
      if (bullet) bullet.textContent = active ? '●' : '○';
    });

    if (this.variantInput) {
      this.variantInput.value = button.dataset.variantId;
    }

    if (this.price && button.dataset.price) {
      this.price.textContent = button.dataset.price;
    }

    const soldOut = button.dataset.soldOut === 'true';

    if (this.addButton) {
      this.addButton.disabled = soldOut;
      this.addButton.textContent = soldOut ? 'SOLD OUT' : 'ADD TO BAG';
    }

    const mediaId = button.dataset.mediaId;

    if (mediaId) {
      const slideIndex = this.slides.findIndex(
        slide => slide.dataset.mediaId === mediaId
      );

      if (slideIndex !== -1) {
        this.show(slideIndex);
      }
    }
  }
}

function initBrickMagazineProducts(root = document) {
  root.querySelectorAll('[data-brick-magazine-product]').forEach(element => {
    if (element.dataset.initialised === 'true') return;

    element.dataset.initialised = 'true';
    new BrickMagazineProduct(element);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initBrickMagazineProducts();
});

document.addEventListener('shopify:section:load', event => {
  initBrickMagazineProducts(event.target);
});